import { useNavigate } from "react-router-dom";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
} from "@mui/material";
import React from "react";
import TransactionHistory from "../../features/manageUsers/transctionHistory";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TransctionLog from "../transction-history/transctionLog";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TableHeader = ({ minimal = false }: { minimal?: boolean }) => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
    const [Status, setStatus] = React.useState("default");
  const [store, setStore] = React.useState("default");
  const [user, setUser] = React.useState("default");

  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const handleStatusChange1 = (event: SelectChangeEvent) => {
    setStore(event.target.value as string);
  };
  const handleStatusChange2 = (event: SelectChangeEvent) => {
    setUser(event.target.value as string);
  };

  return (
    <div className="table_header">
      <div className="left_s">
        <SearchBar
          searchTerm={searchTerm}
          setDebouncedSearchTerm={setSearchTerm}
          placeholder="Search..."
        />
        {!minimal && (
          <>
            <div className=" form">
              <Select fullWidth value={Status} onChange={handleStatusChange}>
                <MenuItem disabled value="default">
                  Select Type
                </MenuItem>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Earned">Earned</MenuItem>
                <MenuItem value="Redeemed">Redeemed</MenuItem>
                <MenuItem value="Expired">Expired</MenuItem>
              </Select>
            </div>
            <div className=" form">
              <Select fullWidth value={store} onChange={handleStatusChange1}>
                <MenuItem disabled value="default">
                  Select Source
                </MenuItem>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="1">Store </MenuItem>
                <MenuItem value="2">App</MenuItem>
                <MenuItem value="3">QR</MenuItem>
              </Select>
            </div>
            {/* <div className=" form">
              <Select fullWidth value={user} onChange={handleStatusChange2}>
                <MenuItem disabled value="default">
                  Select User
                </MenuItem>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="1">User 1</MenuItem>
                <MenuItem value="2">User 2</MenuItem>
              </Select>
            </div> */}
            <div className="form">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/date_icon.svg" alt="Pick date" />
                    ),
                  }}
                  slotProps={{
                    textField: {
                      id: "dob",
                      placeholder: "Select Date",
                      fullWidth: true,
                      hiddenLabel: true,
                    },
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>
          </>
        )}

      </div>
      {!minimal && (
        <div className="right_s">
          <Button className="btn btn_black"><FileDownloadIcon /> Export CSV</Button>
        </div>
      )}
    </div>
  );
};

const ManageTransction = () => {
  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>Transactions & Loyalty Logs</h1>
        <p>
          <button
            onClick={() => navigate("/dashboard")}
            className="btn btn_primary"
          >
            Dashboard
          </button>{" "}
          - Transactions & Loyalty Logs
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Transction History" {...a11yProps(0)} />
              <Tab label="Points Adjustment Log" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <TableHeader />
          <TransactionHistory />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <TableHeader minimal />
          <TransctionLog />
          
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ManageTransction;
